import { render, staticRenderFns } from "./GeneratePixInstallmentPlanSidebar.vue?vue&type=template&id=11466906"
import script from "./GeneratePixInstallmentPlanSidebar.vue?vue&type=script&lang=js"
export * from "./GeneratePixInstallmentPlanSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports